import { useEffect, useRef, useState } from "react";
import React from "react";
import Template from "../../component/Template.js";
import Api from "../../component/Api";
import useAuth from "../../component/useAuth.js";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import Select from "react-select";

export default function CCAMarkList() {
  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/admin/");
  }

  const [loading, setlodaing] = useState(false);
  const { http } = Api();

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
    }),

    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
    }),

    multiValue: (provided) => ({
      ...provided,
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };

  const studentData = [
    {
      apaar: "12345",
      name: "John Doe",
      courses: [
        {
          courseCode:
            "DSC 1: MG1DSCBOT100-Fascinating world of plant sciences-Botany-AIDED",
          no_of_co: 5,
          data: [
            {
              type: "T:E",
              CO: [5, 2, 1, 2, 0],
              status: "Forwarded to University",
              attendance: "P",
            },
            {
              type: "P:E",
              CO: [5, 2, 1, 2, 0],
              status: "Forwarded to University",
              attendance: "P",
            },
            {
              type: "T:I",
              CO: [5, 2, 1, 2, 0],
              status: "Forwarded to University",
              attendance: "P",
            },
          ],
        },
        {
          courseCode:
            "DSC 2: MG1DSCZGY100-Introduction to zoology-Zoology-AIDED",
          no_of_co: 4,
          data: [
            {
              type: "T:E",
              CO: [3, 1, 4, 0],
              status: "Forwarded to University",
              attendance: "A",
            },
            {
              type: "P:I",
              CO: [3, 1, 4, 0],
              status: "DEO Forwarded",
              attendance: "M",
            },
          ],
        },
        {
          courseCode:
            "DSC 3: MG1DSCCHE100-Fundamentals of chemistry-1-Chemistry-AIDED",
          no_of_co: 4,
          data: [
            {
              type: "T:E",
              CO: [3, 1, 4, 0],
              status: "Forwarded to University",
              attendance: "A",
            },
            {
              type: "P:I",
              CO: [3, 1, 4, 0],
              status: "DEO Forwarded",
              attendance: "M",
            },
          ],
        },
        {
          courseCode: "MDC: MG1MDCPES100-Basic first aid and cpr-BPES-AIDED",
          no_of_co: 4,
          data: [
            {
              type: "T:E",
              CO: [3, 1, 4, 0],
              status: "Forwarded to University",
              attendance: "A",
            },
            {
              type: "P:I",
              CO: [3, 1, 4, 0],
              status: "DEO Forwarded",
              attendance: "M",
            },
          ],
        },
        {
          courseCode:
            "AEC 1: MG1AECENG100-English for science part I-English-AIDED",
          no_of_co: 4,
          data: [
            {
              type: "T:E",
              CO: [3, 1, 4, 0],
              status: "Forwarded to University",
              attendance: "A",
            },
            {
              type: "P:I",
              CO: [3, 1, 4, 0],
              status: "DEO Entered",
              attendance: "M",
            },
          ],
        },
        {
          courseCode:
            "AEC 2: MG1AECHIN100-हिंदी साहित्य में पर्यावरण (Environment in Hindi Literature – For Science)-Hindi-AIDED",
          no_of_co: 5,
          data: [
            {
              type: "T:E",
              CO: [3, 1, 4, 0, 1],
              status: "Forwarded to University",
              attendance: "A",
            },
            {
              type: "P:I",
              CO: [3, 1, 4, 0, 2],
              status: "DEO Forwarded",
              attendance: "M",
            },
          ],
        },
      ],
    },
    {
      apaar: "54321",
      name: "Jane Smith",
      courses: [
        {
          courseCode: "MGDSC102",
          no_of_co: 3,
          data: [
            {
              type: "T:I",
              CO: [1, 3, 5],
              status: "DEO Forwarded",
              attendance: "M",
            },
          ],
        },
      ],
    },
  ];

  // Find the maximum number of COs for all students and courses
  const maxCOs = Math.max(
    ...studentData.flatMap((student) =>
      student.courses.map((course) => course.no_of_co)
    )
  );

  return (
    <>
      <ToastContainer />
      <Template>
        {loading ? (
          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div
                    className="card-body d-flex justify-content-center align-items-center"
                    style={{ minHeight: "400px" }}
                  >
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center ">
                        <h5>Mark Entry Status</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div
                          className="table-responsive"
                          style={{ overflowX: "unset" }}
                        >
                          <form className="form theme-form">
                            <div className="card-body custom-input">
                              <div className="row">
                                <div className="col-md-6">
                                  <label>
                                    Examination{" "}
                                    <span className="errorclr">*</span>
                                  </label>
                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="exam"
                                    name="exam"
                                    className="form"
                                    styles={customStyles}
                                  />
                                </div>

                                <div className="col-md-6">
                                  <label>
                                    Admitted Discipline{" "}
                                    <span className="errorclr">*</span>
                                  </label>
                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="discipline"
                                    name="discipline"
                                    className="form"
                                    styles={customStyles}
                                  />
                                </div>
                              </div>

                              <div className="table-responsive">
                                <table
                                  className="table  table-bordered"
                                  style={{
                                    fontSize: "12px",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <thead>
                                    <tr style={{ backgroundColor: "#581f37" }}>
                                      <th
                                        colSpan="9"
                                        className="text-center"
                                        style={{
                                          backgroundColor: "#581f37",
                                          color: "white",
                                          padding: "5px",
                                        }}
                                      >
                                        <strong>Apaar:</strong> 12345 -{" "}
                                        <strong>Name:</strong> John Doe
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      className="bg-dark text-light text-center"
                                      style={{
                                        lineHeight: "1",
                                        padding: "5px",
                                      }}
                                    >
                                      <th
                                        className="align-middle"
                                       
                                        rowSpan="4"
                                      >
                                        Course
                                      </th>
                                      <th style={{ padding: "5px" }}>Type</th>
                                      <th style={{ padding: "5px" }}>CO1</th>
                                      <th style={{ padding: "5px" }}>CO2</th>
                                      <th style={{ padding: "5px" }}>CO3</th>
                                      <th style={{ padding: "5px" }}>CO4</th>
                                      <th style={{ padding: "5px" }}>CO5</th>
                                      <th style={{ padding: "5px" }}>A/M/P</th>
                                      <th
                                        style={{ width: "40%", padding: "5px" }}
                                      >
                                        Status
                                      </th>
                                    </tr>

                                    <tr
                                      className="text-center align-middle"
                                      style={{
                                        lineHeight: "1",
                                        padding: "5px",
                                      }}
                                    >
                                      <td style={{ padding: "5px" }}>Exam</td>
                                      <td style={{ padding: "5px" }}>1</td>
                                      <td style={{ padding: "5px" }}>2</td>
                                      <td style={{ padding: "5px" }}>3</td>
                                      <td style={{ padding: "5px" }}>4</td>
                                      <td style={{ padding: "5px" }}>5</td>
                                      <td style={{ padding: "5px" }}>
                                        Present
                                      </td>
                                      <td style={{ padding: "5px" }}>Passed</td>
                                    </tr>

                                    <tr
                                      className="text-center align-middle"
                                      style={{
                                        lineHeight: "1",
                                        padding: "5px",
                                      }}
                                    >
                                      <td style={{ padding: "5px" }}>Exam</td>
                                      <td style={{ padding: "5px" }}>1</td>
                                      <td style={{ padding: "5px" }}>2</td>
                                      <td style={{ padding: "5px" }}>3</td>
                                      <td style={{ padding: "5px" }}>4</td>
                                      <td style={{ padding: "5px" }}>5</td>
                                      <td style={{ padding: "5px" }}>
                                        Present
                                      </td>
                                      <td style={{ padding: "5px" }}>Passed</td>
                                    </tr>

                                    <tr
                                      className="text-center align-middle"
                                      style={{
                                        lineHeight: "1",
                                        padding: "5px",
                                      }}
                                    >
                                      <td style={{ padding: "5px" }}>Exam</td>
                                      <td style={{ padding: "5px" }}>1</td>
                                      <td style={{ padding: "5px" }}>2</td>
                                      <td style={{ padding: "5px" }}>3</td>
                                      <td style={{ padding: "5px" }}>4</td>
                                      <td style={{ padding: "5px" }}>5</td>
                                      <td style={{ padding: "5px" }}>
                                        Present
                                      </td>
                                      <td style={{ padding: "5px" }}>Passed</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                              <table
                                className="table-striped  table-bordered ex-table  mb-10"
                                style={{ width: "100%" }}
                              >
                                <tbody>
                                  {studentData.map((student, studentIndex) => (
                                    <React.Fragment
                                      key={`student-${studentIndex}`}
                                    >
                                      {/* Student Header */}
                                      <tr className="bg-primary">
                                        <td
                                          colSpan={maxCOs + 4}
                                          className="bg-primary"
                                        >
                                          <strong>Apaar:</strong>{" "}
                                          {student.apaar} -{" "}
                                          <strong>Name:</strong> {student.name}
                                        </td>
                                      </tr>

                                      {/* Courses and Data */}
                                      {student.courses.map(
                                        (course, courseIndex) => (
                                          <React.Fragment
                                            key={`course-${courseIndex}`}
                                          >
                                            <tr>
                                              {/* Add a custom style for the courseCode column */}
                                              <td
                                                style={{
                                                  width: "30%", // Adjust the width as per your requirement
                                                  whiteSpace: "pre-wrap", // Ensure long text wraps properly
                                                  wordBreak: "break-word", // Prevent overflow for long words
                                                  fontSize: "11px",
                                                }}
                                                rowSpan={course.data.length + 1}
                                              >
                                                {course.courseCode}
                                              </td>
                                              <td></td>
                                              {Array.from(
                                                { length: maxCOs },
                                                (_, i) => (
                                                  <td
                                                    className="bg-dark"
                                                    key={`header-CO${i + 1}`}
                                                    style={{
                                                      fontSize: "11px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {i < course.no_of_co
                                                      ? `CO${i + 1}`
                                                      : ""}
                                                  </td>
                                                )
                                              )}
                                              <td
                                                className="bg-dark"
                                                style={{
                                                  fontSize: "11px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                A/M/P
                                              </td>
                                              <td
                                                className="bg-dark"
                                                style={{
                                                  fontSize: "11px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Status
                                              </td>
                                            </tr>
                                            {course.data.map(
                                              (row, rowIndex) => (
                                                <tr key={`row-${rowIndex}`}>
                                                  <td
                                                    style={{
                                                      fontSize: "11px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {row.type}
                                                  </td>
                                                  {Array.from({
                                                    length: maxCOs,
                                                  }).map((_, i) => (
                                                    <td
                                                      key={`CO-${i}`}
                                                      style={{
                                                        fontSize: "11px",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      {row.CO[i] !== undefined
                                                        ? row.CO[i]
                                                        : ""}
                                                    </td>
                                                  ))}
                                                  <td
                                                    style={{
                                                      fontSize: "11px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {row.attendance}
                                                  </td>
                                                  <td
                                                    style={{
                                                      fontSize: "11px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {row.status}
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </React.Fragment>
                                        )
                                      )}
                                    </React.Fragment>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Template>
    </>
  );
}
